export default __webpack_public_path__ + "static/media/calendar-icon-blue.bcf2722e.svg";